import {createSelector} from '@reduxjs/toolkit';

import {AppState} from 'store';

import {ProfileState} from './profile.reducer';

const profile = (state: AppState): ProfileState => state.profile ?? {};

export const profileNavItemsSelector = createSelector(
  [profile],
  profileState => {
    const profileTabs = profileState?.profileTabs ?? [];
    return profileTabs.map((tabName: string) => ({text: tabName}));
  }
);

export const updatedUserInfoSelector = createSelector(
  profile,
  profileState => profileState.updatedUserInfo
);

export const updatedUserInfoCompanionIdSelector = createSelector(
  updatedUserInfoSelector,
  updatedUserInfo => updatedUserInfo?.companionNumber
);

export const paymentModuleStateSelector = createSelector(
  profile,
  state => state.paymentModuleState
);

export const isMFATokenValidSelector = createSelector(
  profile,
  profileState => profileState.isMFATokenValid
);

export const profileInfoStateSelector = createSelector(
  profile,
  profileState => profileState.updateProfileInfoState
);

export const lastGetProfileFullInfoTimeSelector = createSelector(
  profile,
  state => state.lastGetProfileFullInfoTime
);

export const updateCompanionNumberStateSelector = createSelector(
  profile,
  state => state.updateCompanionNumberState
);

export const getBreadSDKErrorStateSelector = createSelector(
  profile,
  state => state.breadSDKError
);
